import { makeAutoObservable, toJS } from 'mobx';

class Transformation {
  constructor(initialState = {}) {
    makeAutoObservable(this);

    this.setTableNames = this.setTableNames.bind(this);
    this.setSelectedTableName = this.setSelectedTableName.bind(this);
  }

  rawTableNames = [];
  rawSelectedTableName = null;

  setTableNames(values) {
    this.rawTableNames = [...(values || [])];
  }

  setSelectedTableName(value) {
    this.rawSelectedTableName = value;
  }

  get tableNames() {
    return toJS(this.rawTableNames);
  }
  get selectedTableName() {
    return toJS(this.rawSelectedTableName);
  }
}

const transformationStore = new Transformation();

export default transformationStore;
